<template>
  <div v-if="pageId" class="messenger-widget">
    <div id="fb-root"></div>
    <div ref="chatbox" id="fb-customer-chat" class="fb-customerchat"></div>
  </div>
</template>

<script>
export default {
  name: "MessengerWidget",
  props: {
    pageId: {
      type: String,
      default: () => process.env.VUE_APP_FB_PAGE_ID || ""
    },
    attribution: {
      type: String,
      default: "biz_inbox"
    },
    themeColor: {
      type: String,
      default: "#C4A461"
    },
    loggedInGreeting: {
      type: String,
      default: ""
    },
    loggedOutGreeting: {
      type: String,
      default: ""
    },
    greetingDialogDisplay: {
      type: String,
      default: "show"
    },
    locale: {
      type: String,
      default: "en_US"
    },
    sdkVersion: {
      type: String,
      default: "v19.0"
    }
  },
  watch: {
    pageId(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.$nextTick(() => {
          this.setupChatAttributes();
          this.loadSdk();
        });
      }
    }
  },
  mounted() {
    if (!this.pageId) {
      if (process.env.NODE_ENV !== "production") {
        console.warn(
          "[MessengerWidget] Missing Facebook page id. Set VUE_APP_FB_PAGE_ID or pass the page-id prop."
        );
      }
      return;
    }

    this.setupChatAttributes();
    this.loadSdk();
  },
  methods: {
    setupChatAttributes() {
      const chatbox = this.$refs.chatbox;

      if (!chatbox) {
        return;
      }

      chatbox.setAttribute("page_id", this.pageId);
      chatbox.setAttribute("attribution", this.attribution);

      if (this.themeColor) {
        chatbox.setAttribute("theme_color", this.themeColor);
      }

      if (this.loggedInGreeting) {
        chatbox.setAttribute("logged_in_greeting", this.loggedInGreeting);
      }

      if (this.loggedOutGreeting) {
        chatbox.setAttribute("logged_out_greeting", this.loggedOutGreeting);
      }

      if (this.greetingDialogDisplay) {
        chatbox.setAttribute("greeting_dialog_display", this.greetingDialogDisplay);
      }
    },
    loadSdk() {
      if (typeof window === "undefined") {
        return;
      }

      if (window.FB) {
        this.parseXfbml();
        return;
      }

      const initCallback = () => {
        if (window.FB) {
          if (!window.__fbSdkInitialized) {
            window.FB.init({
              xfbml: true,
              version: this.sdkVersion
            });
            window.__fbSdkInitialized = true;
          }
          this.parseXfbml();
        }
      };

      const previousFbAsyncInit = window.fbAsyncInit;
      window.fbAsyncInit = () => {
        if (typeof previousFbAsyncInit === "function") {
          previousFbAsyncInit();
        }
        initCallback();
      };

      if (document.getElementById("facebook-jssdk")) {
        return;
      }

      const script = document.createElement("script");
      script.id = "facebook-jssdk";
      script.async = true;
      script.defer = true;
      script.src = `https://connect.facebook.net/${this.locale}/sdk/xfbml.customerchat.js`;
      script.onload = () => {
        initCallback();
      };
      script.onerror = () => {
        if (process.env.NODE_ENV !== "production") {
          console.error("[MessengerWidget] Failed to load the Facebook SDK.");
        }
      };

      document.body.appendChild(script);
    },
    parseXfbml() {
      if (window.FB && window.FB.XFBML && typeof window.FB.XFBML.parse === "function") {
        window.FB.XFBML.parse();
      }
    }
  }
};
</script>

